import { getRenewVehiclesRequest } from "../data/renewVehicleApi";

export async function getRenewVehiclesUseCase(token) {
  if (!token) throw new Error("Inicia sesión como administrador para ver las solicitudes");
  const response = await getRenewVehiclesRequest(token);
  if (response.data?.message !== "ok" || !Array.isArray(response.data.data)) {
    throw new Error("Respuesta inválida al consultar vehículos para renovar");
  }
  return response.data.data;
}
